import { inject, injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { FeeLadderModel } from "@/core/models/fee-ladder.model";
import { AddressRepo } from "../address.repo";

interface _FeeLadderGetParams {
    search?: string;
}

@injectable()
export class FeeLadderRepo extends TableRepo<FeeLadderModel> {
    @inject(AddressRepo)
    private addressRepo!: AddressRepo;

    constructor() {
        super("/api/FeeLadder");
    }

  async getData(index: number, params: _FeeLadderGetParams, pageSize = 10): Promise<ApiPage<FeeLadderModel>|null> {
        const result = await super.getData(index, params, pageSize)
        if (result) {
            const data: FeeLadderModel[] = [];
            for (const record of result.data) {
                const [province] = await Promise.all([
                    this.addressRepo.getProvince(record.provinceId),
                ])
                const populatedRecord: FeeLadderModel = {
                    ...record,
                    provinceName: province?.name,
                };
                data.push(populatedRecord);
            }
            result.data = data;
            return result;
        }
        return null;
    }
}